import ProductSelect, { type ProductSelectProps } from './ProductSelect';

export type { ProductSelectProps };
export default ProductSelect;
